import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { QBadge, QDivider, QLink, QStack, QText } from '@qualio/ui-components';

import { DocumentOverviewContext } from '../../Context';
import { shouldRenderRelatedIssues } from '../../RenderLogic';

export const ViewIssue = () => {
  const { t } = useTranslation();
  const { qualioDocument } = useContext(DocumentOverviewContext);

  const url = `/quality-events/events/${qualioDocument.issue_id}`;

  if (!shouldRenderRelatedIssues(qualioDocument)) {
    return null;
  }

  const issueCode = qualioDocument.issue?.code;

  return (
    <>
      <QStack>
        <QText fontWeight="semibold" fontSize="md">
          {t('labels.event')}
        </QText>
        <QStack>
          <QBadge mt="4.5">
            <QLink isCrossMFE href={url}>
              {issueCode}
            </QLink>
          </QBadge>
        </QStack>
      </QStack>
      <QDivider mt="6" mb="6" />
    </>
  );
};
